import React from 'react';
import {
  OrganizationCollapseButtons,
  CollapseBtn,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/organizationDetails';
import { Chevron } from '../../../../../../editJournal/toolset/assets/icons';

const CollapseButton = (props) => {
  const collapseHandler = () => {
    const { node, editor } = props;

    const {
      value: { document: currentDocument },
    } = editor;

    const { key: organizationDetailsKey } = node;

    const organizationNode = currentDocument.getParent(organizationDetailsKey);

    const { key: organizationKey, data: organizationData } = organizationNode;

    const organizationDataJSON = organizationData.toJSON();

    const isCollapseOrg =
      (organizationDataJSON && organizationDataJSON.isCollapseChildren) ||
      false;

    editor
      .setNodeByKey(organizationKey, {
        data: {
          ...organizationDataJSON,
          isCollapseChildren: !isCollapseOrg,
        },
      })
      .blur();
  };

  const { isCollapseChildren, node } = props;

  return (
    <OrganizationCollapseButtons
      contentEditable={false}
      isCollapseChildren={isCollapseChildren}
    >
      <CollapseBtn
        onMouseDown={(e) => e.preventDefault()}
        onClick={collapseHandler}
        contentEditable={false}
        isCollapseChildren={isCollapseChildren}
        data-testid={`${isCollapseChildren ? `collapsed_` : 'expanded_'}${
          node.type
        }_button`}
      >
        <Chevron width="16px" height="16px" fill="#474747" />
      </CollapseBtn>
    </OrganizationCollapseButtons>
  );
};

export default CollapseButton;
